// extracted by mini-css-extract-plugin
module.exports = {"Page500":"Page500_Page500__17fmG","Logo":"Page500_Logo__1-eZm","ErrorNum":"Page500_ErrorNum__25j8_","Tit":"Page500_Tit__3Xsp2"};